// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pu_a bhu_cw bhu_jx bhu_jo bhu_a bhu_j bhu_ri bhu_rj","SearchPanel__icon":"pu_b bhu_ui bhu_hb bhu_ro bhu_tu","SearchPanel__input":"pu_c bhu_iv bhu_cx bhu_z"};